























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeReferensi } from "@/store/modules/referensi";

interface AutocompleteOptions {
  outlined: true;
  label: "";
}

@Component({
  components: {},
})
export default class DokterAutoComplete extends Vue {
  @Prop() setDokter!: object;

  @Prop({
    default: () => {
      return {
        outlined: true,
        label: null,
      };
    },
  })
  opt: AutocompleteOptions;

  get listDokter() {
    return storeReferensi.dokter;
  }

  // listDokter = [
  //   {
  //     id: "1",
  //     nama: "dr. adnan",
  //   },
  //   {
  //     id: "2",
  //     nama: "dr. toni",
  //   },
  //   {
  //     id: "3",
  //     nama: "dr. strange",
  //   },
  // ];

  dokter = {};

  list = [];

  searchDokter = null;

  loading = false;

  @Watch("setDokter")
  valDokter(val) {
    this.$emit("dokter", val);
  }
}
